var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconChevronBig = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#FF3118",
  viewBox: "0 0 48 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 42.727V10.5a6 6 0 0 1 6-6h24a6 6 0 0 1 6 6v32.227c0 1.982-2.376 2.996-3.807 1.625L24 30.75 9.807 44.352C8.377 45.722 6 44.709 6 42.727"
})));
export default SvgIconChevronBig;